module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAICAYAAABQ6Rd5AAAAtElEQVQ4jc3UsYkCQRiG4ee2ADG7CsQStABZrhbBXDBfjC3EVJAr4ErwMDMzEy1A+WUCXXYXTHTebGY++N8PZuZrNL3CAEtM0PN+zvjFHPuG6TOsHtZP+SgxxB/6H5Cvc8IY/7X9H2za8gWqTApIHlXD/qErX6QrlBNlg8uxw68sMivQxrnrsEgPJCe2L7pso8QiPZAcCI/wqdP2Y97zUWKXfoQ1Lh8qEnNjfniET53v1jy7G8ZZJG7iyJktAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/prodCore/产品业务结构icon.png
// module id = 5ClW
// module chunks = 0 2